const { useState } = React;

function Navigation() {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    return (
        <nav className="fixed top-0 left-0 right-0 z-50 nav-glass backdrop-blur-lg">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-16">
                    {/* Logo */}
                    <div className="flex-shrink-0">
                        <a href="#home" className="flex items-center gap-3">
                            <img
                                src="assets/beasmar-logo.jpg"
                                alt="BEASMAR logo"
                                className="h-8 w-8 sm:h-9 sm:w-9 rounded-xl object-cover border border-blue-200/60 bg-white"
                            />
                            <span className="text-xl sm:text-2xl font-bold text-gradient tracking-tight">
                                BEASMAR
                            </span>
                        </a>
                    </div>

                    {/* Desktop Menu */}
                    <div className="hidden md:flex items-center space-x-8">
                        <a href="#about" className="nav-link">
                            About
                        </a>
                        <a href="#how-it-works" className="nav-link">
                            How It Works
                        </a>
                        <a href="#advantages" className="nav-link">
                            Why Choose Us
                        </a>
                        <a href="agent.html?tab=plans" className="nav-link">
                            Plans
                        </a>
                    </div>

                    {/* CTA Buttons */}
                    <div className="hidden md:flex items-center space-x-4">
                        <a href="customer.html" className="btn-secondary btn-sm">
                            Client
                        </a>
                        <a href="agent.html" className="btn-primary btn-sm">
                            Realtors
                        </a>
                    </div>

                    {/* Mobile Menu Button */}
                    <button
                        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                        className="md:hidden p-2 text-gray-700"
                    >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                        </svg>
                    </button>
                </div>

                {/* Mobile Menu */}
                {mobileMenuOpen && (
                    <div className="md:hidden pb-4 space-y-3">
                        <a href="#about" className="block nav-link">About</a>
                        <a href="#how-it-works" className="block nav-link">How It Works</a>
                        <a href="#advantages" className="block nav-link">Why Choose Us</a>
                        <a href="agent.html?tab=plans" className="block nav-link">Plans</a>
                        <div className="flex gap-3 pt-4">
                            <a href="customer.html" className="flex-1 btn-secondary btn-sm">
                                Client
                            </a>
                            <a href="agent.html" className="flex-1 btn-primary btn-sm">
                                Realtors
                            </a>
                        </div>
                    </div>
                )}
            </div>
        </nav>
    );
}

export default Navigation;
